export default "__VITE_ASSET__xZbtpKRe__"